import "@sakai-ui/sakai-permissions/sakai-permissions.js";
import "@sakai-ui/sakai-search/sakai-search.js";
import { init as initJumpToTop } from "@sakai-ui/sakai-jump-to-top/sakai-jump-to-top.js";
initJumpToTop();
